import { useState } from "react";
import { FaAngleRight, FaRegStar } from "react-icons/fa6";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../../components/elements/LoadingSpinner";
import { BsEye } from "react-icons/bs";
import MealModal from "../../../../components/modals/Restaurant/MealModal";

// Meal interface matching MealType from MealModal
interface Meal {
  id: number;
  name: string;
  category: string;
  restaurant: string;
  description: string;
  image: string;
  lastUpdated: string;
  price: number;
  rating: number;
  orders: number;
  status: string;
}

// Mock meal details for modal (replace with real data)
const mockMealDetails: Meal = {
  id: 1,
  name: "Sample Meal",
  category: "Main Course",
  restaurant: "The Place Restaurant",
  description: "Sample description",
  image: "/assets/avatar.svg",
  lastUpdated: "2024-01-01",
  price: 2500,
  rating: 4.5,
  orders: 120,
  status: "available"
};

const meals: Meal[] = [
  {
    id: 1,
    name: "Jollof Rice",
    category: "Rice Dish",
    restaurant: "The Place Restaurant",
    description: "Delicious Nigerian jollof rice with spices",
    image: "/assets/avatar.svg",
    lastUpdated: "2024-01-01",
    price: 2500,
    rating: 4.5,
    orders: 120,
    status: "available",
  },
  {
    id: 2,
    name: "Fried Plantain",
    category: "Snacks",
    restaurant: "The Place Restaurant",
    description: "Sweet fried plantain slices",
    image: "/assets/avatar.svg",
    lastUpdated: "2024-01-01",
    price: 1500,
    rating: 4.0,
    orders: 80,
    status: "available",
  },
  {
    id: 3,
    name: "Chicken Soup",
    category: "Soup",
    restaurant: "The Place Restaurant",
    description: "Rich chicken soup with vegetables",
    image: "/assets/avatar.svg",
    lastUpdated: "2024-01-01",
    price: 3000,
    rating: 4.8,
    orders: 200,
    status: "unavailable",
  },
  {
    id: 4,
    name: "Beef Stew",
    category: "Soup",
    restaurant: "The Place Restaurant",
    description: "Tender beef stew with local spices",
    image: "/assets/avatar.svg",
    lastUpdated: "2024-01-01",
    price: 3500,
    rating: 4.6,
    orders: 150,
    status: "available",
  },
  {
    id: 5,
    name: "Pounded Yam",
    category: "Swallow",
    restaurant: "The Place Restaurant",
    description: "Fresh pounded yam served hot",
    image: "/assets/avatar.svg",
    lastUpdated: "2024-01-01",
    price: 2000,
    rating: 4.3,
    orders: 90,
    status: "available",
  },
  {
    id: 6,
    name: "Meat Pie",
    category: "Pasteries",
    restaurant: "The Place Restaurant",
    description: "Crispy meat pie with beef filling",
    image: "/assets/avatar.svg",
    lastUpdated: "2024-01-01",
    price: 800,
    rating: 4.2,
    orders: 300,
    status: "available",
  },
];

const VendorMeals = () => {
  const [tab, setTab] = useState<string>("pastries");
  const [selectedMeal, setSelectedMeal] = useState<Meal | null>(null);
  const [loading] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <section className="font-mont">
      <div className="flex items-start gap-4">
        <button
          className="cursor-pointer p-2 rounded-full bg-[#008B5014]"
          onClick={() => navigate(-1)}
        >
          <MdOutlineKeyboardBackspace className="w-6 h-6" />
        </button>
        <article>
          <h1 className="text-2xl font-medium mb-2 inline-flex items-center gap-3">
            <span className="font-semibold">Restaurant</span> <FaAngleRight />
            <span className="font-semibold">The Place Restaurant - Meals</span>
          </h1>
          <p className="text-sm">Menu Items</p>
        </article>
      </div>
      <nav className="my-5">
        <ul className="flex items-center w-fit gap-3 text-gray-500 font-medium">
          <li
            className={`p-2 cursor-pointer ${
              tab === "pastries" && "text-secondary bg-gray-100 rounded-md"
            }`}
            onClick={() => setTab("pastries")}
          >
            Pasteries
          </li>
          <li
            className={`p-2 cursor-pointer ${
              tab === "rice" && "text-secondary bg-gray-100 rounded-md"
            }`}
            onClick={() => setTab("rice")}
          >
            Rice Dish
          </li>
          <li
            className={`p-2 cursor-pointer ${
              tab === "swallow" && "text-secondary bg-gray-100 rounded-md"
            }`}
            onClick={() => setTab("swallow")}
          >
            Swallow
          </li>
          <li
            className={`p-2 cursor-pointer ${
              tab === "soup" && "text-secondary bg-gray-100 rounded-md"
            }`}
            onClick={() => setTab("soup")}
          >
            Soup
          </li>
          <li
            className={`p-2 cursor-pointer ${
              tab === "snacks" && "text-secondary bg-gray-100 rounded-md"
            }`}
            onClick={() => setTab("snacks")}
          >
            Snacks
          </li>
          <li
            className={`p-2 cursor-pointer ${
              tab === "drinks" && "text-secondary bg-gray-100 rounded-md"
            }`}
            onClick={() => setTab("drinks")}
          >
            Drinks
          </li>
        </ul>
      </nav>
      <table className="w-full">
        <thead className="font-normal">
          <tr className="bg-gray-100 text-left">
            <th className="p-3 font-medium">Item</th>
            <th className="p-3 font-medium">Price</th>
            <th className="p-3 font-medium">Rating</th>
            <th className="p-3 font-medium">Orders</th>
            <th className="p-3 font-medium">status</th>
            <th className="p-3 font-medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td>
                <LoadingSpinner />
              </td>
            </tr>
          ) : meals.length > 0 ? (
            meals.map((meal) => (
              <tr key={meal.id} className="border text-sm">
                <td className="p-5">
                  <div className="flex items-center gap-2">
                    <img
                      src={meal.image}
                      alt={meal.name}
                      className="w-12 h-12 object-cover rounded-md"
                    />
                    {meal.name}
                  </div>
                </td>
                <td className="p-5">N{meal.price}</td>

                <td className="p-5">
                  <div className="flex items-center gap-1">
                    {meal.rating} <FaRegStar className="text-orange100" />
                  </div>
                </td>
                <td className="p-5">{meal.orders}</td>
                <td className="p-5">
                  <p
                    className={`${
                      meal.status === "available"
                        ? "bg-[#008B501F] text-secondary"
                        : meal.status === "unavailable"
                        ? "text-red-500 bg-[#EA19191F]"
                        : ""
                    } text-center font-semibold rounded-md p-1 text-[12px]`}
                  >
                    {meal.status}
                  </p>
                </td>
                <td className="p-5">
                  <button
                    className="text-secondary border border-secondary rounded-md px-6 py-1 flex items-center gap-3"
                    onClick={() => setSelectedMeal(mockMealDetails)}
                  >
                    <BsEye /> View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td>No data available</td>
            </tr>
          )}
        </tbody>
      </table>
      {selectedMeal && (
        <MealModal
          toggleModal={() => setSelectedMeal(null)}
          meal={selectedMeal}
        />
      )}
    </section>
  );
};

export default VendorMeals;
